import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  Tooltip,
  Legend,
  CartesianGrid,
  XAxis,
  YAxis,
  Cell,
} from "recharts";
import { Spinner, Alert } from "react-bootstrap";

const TopPartnersAnalytics = ({ startDate, endDate }) => {
  const [topPartners, setTopPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!startDate || !endDate) return;
    const fetchAnalytics = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${apiUrl}/admin/analytics/top-partners?start_date=${startDate}&end_date=${endDate}`,
          {
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error("Ошибка загрузки данных");
        }

        const data = await response.json();
        setTopPartners(data);
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
        setError("Не удалось загрузить данные.");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [apiUrl, startDate, endDate]);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#FF6384"];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-baseline mb-3">
        <h3 className="mb-0">Топ лидеров продаж по сумме</h3>
        <p className="text-muted small mb-0">
          Период: {startDate} — {endDate}
        </p>
      </div>

      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" variant="primary" />
          <p>Загрузка данных...</p>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : topPartners.length === 0 ? (
        <Alert variant="info">Нет данных для отображения</Alert>
      ) : (
        <div className="chart-responsive">
          <BarChart
            width={600}
            height={400}
            data={topPartners}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 50,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 10, angle: -5 }}
              interval={0}
              height={40}
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="total_sales" fill="#8884d8">
              {topPartners.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </div>
      )}
    </div>
  );
};

export default TopPartnersAnalytics;
TopPartnersAnalytics.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};
